// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> cobalt-theme-avenue -> the-heights-at-happy-valley
// Generated: 2026-10-28T17:10:12.161Z
// Counts: 4 design, 47 content, 38 slot group, 5 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Lato', sans-serif",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Lato', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "New Apartments in Happy Valley, Oregon",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/property/6767906449167749/01a05871-9d7c-746b-8636-cd4abe749f67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Heights at Happy Valley, the amenities extend from your front door to the trails beyond it. Inside your home, stainless-steel appliances, quartz countertops, walk-in closets, and an in-home washer and dryer make everyday routines easier. Browse our <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> to find the layout that fits you best.</p><p>Across the community, unwind at the resort-style pool and spa, keep your routine going at the 24/7 fitness center and sauna, or meet neighbors at the clubhouse lounge, pickleball court, and outdoor living area with BBQs. Our coworking space, secure package room, covered parking, and EV charging handle the practical side, while the bark park, playground, and resident herb garden add something for everyone in your household.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "Features & Amenities at The Heights at Happy Valley",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "commercial-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Retail and service suites are now leasing at The Heights at Happy Valley, a new community with 174 apartment homes on SE Rock Creek Blvd. Two ground-floor spaces face Rock Creek Blvd and share an outdoor plaza. Residents live right upstairs, and I-205 and Highway 26 are a short drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "commercialdetails.footer_heading": {
    "overrideType": "VALUE",
    "customValue": "Looking for an apartment?",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore All <span data-type=\"field-token\" data-field=\"property_name\"></span> Has To Offer</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the floor plan that fits your life at The Heights at Happy Valley. Our one-, two-, and three-bedroom apartments for rent in Happy Valley feature open-concept living, quartz countertops, soft-close cabinets, stainless-steel energy-efficient appliances, hardwood-style plank flooring, and an in-home washer and dryer. Spacious closets with closet systems and a private patio or deck with storage give you room to settle in.</p><p>Need more than a home office? Our live-work units combine comfortable apartment living with dedicated space for creatives, small business owners, and remote professionals, so your commute is measured in steps. Browse the <a class=\"richtext-link\" href=\"/amenities\">community amenities</a> included with every home, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to find your fit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "1, 2 & 3 Bedroom Apartments in Happy Valley, Oregon",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the floor plan that fits your life at The Heights at Happy Valley. Our one-, two-, and three-bedroom apartments for rent in Happy Valley feature open-concept living, quartz countertops, soft-close cabinets, stainless-steel energy-efficient appliances, hardwood-style plank flooring, and an in-home washer and dryer. Spacious closets with closet systems and a private patio or deck with storage give you room to settle in.</p><p>Need more than a home office? Our live-work units combine comfortable apartment living with dedicated space for creatives, small business owners, and remote professionals, so your commute is measured in steps. Browse the community amenities included with every home, then schedule a tour to find your fit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "VALUE",
    "customValue": "Choose Your Floor Plan",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "1, 2 & 3 Bedroom Apartments in Happy Valley, Oregon",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "Elevated Living",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life looks like at The Heights at Happy Valley. Our gallery showcases <a class=\"richtext-link\" href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> with open-concept living, quartz countertops, and private patios or decks, along with live-work units designed for working from home.</p><p>Explore our community spaces too, from the resort-style pool and spa to the 24/7 fitness center and sauna, coworking space, and bark park. When you've seen enough in pictures, <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> and experience our apartments in Happy Valley in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "Photos of The Heights at Happy Valley",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>A Full-Scale Lifestyle at The Heights at Happy Valley</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>More Than a Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the floor plan that fits your life at The Heights at Happy Valley. Our one-, two-, and three-bedroom apartments for rent in Happy Valley feature open-concept living, quartz countertops, soft-close cabinets, stainless-steel energy-efficient appliances, hardwood-style plank flooring, and an in-home washer and dryer. Spacious closets with closet systems and a private patio or deck with storage give you room to settle in.</p><p>Need more than a home office? Our live-work units combine comfortable apartment living with dedicated space for creatives, small business owners, and remote professionals, so your commute is measured in steps. Browse the <a class=\"richtext-link\" href=\"/amenities\">community amenities</a> included with every home, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to find your fit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "1, 2 & 3 Bedroom Apartments in Happy Valley, Oregon",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at The Heights at Happy Valley puts the best of the Pacific Northwest within easy reach. Hike to the summit at Mount Talbert Nature Park, look for waterfalls at Hidden Falls Nature Park, or head out on the bike and walking trails just outside our community. Afterward, grab a drink at Valley Public House or settle in for a tasting at Willamette Valley Vineyards.</p><p>Everyday errands are simple, with Fred Meyer, New Seasons Market, and Clackamas Town Center a short drive away, and Highway 224 connects you to Downtown Portland when you want a night out. Pair it all with a spacious <a class=\"richtext-link\" href=\"/floor-plans\">Happy Valley apartment</a> and see why this corner of Oregon feels like home. <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> with our leasing team today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "Live in Happy Valley, Oregon",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Heights at Happy Valley offers new apartments in Happy Valley, Oregon, designed around the way you live. Our <a class=\"richtext-link\" href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> feature open-concept layouts, quartz countertops, stainless-steel appliances, an in-home washer and dryer, and a private patio or deck with storage.</p><p>Outside your door, spend your downtime at the resort-style pool and spa, get a workout in at the 24/7 fitness center and sauna, or take the dog to our on-site bark park. With access to bike and walking trails, Mount Talbert Nature Park nearby, and quick connections to Highway 224, The Heights at Happy Valley brings Pacific Northwest living and everyday convenience together. <a class=\"richtext-link\" href=\"/amenities\">Explore our amenities</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see it for yourself.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "Welcome to The Heights at Happy Valley",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Tour?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore The Heights at Happy Valley from wherever you are. Our 3D virtual tours let you step inside our new <a class=\"richtext-link\" href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> and see the open-concept layouts, quartz countertops, and private outdoor spaces in detail.</p><p>Whether you're relocating to the Portland area or comparing homes in Happy Valley, our virtual tours make it easy to narrow your search. When you're ready to see it in person, <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> with our leasing team.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tours of Our New Apartments in Happy Valley",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "reviewscallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour Today"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 74,
    "fieldOverrides": null
  },
  "apply-now-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-9ce7-77f8-8842-1b66426970fa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a parking lot and clubhouse."
      }
    }
  },
  "commercialdetails.floorplans_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/interactive-map"
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-83f2-70cc-8465-3658d415f580.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a large island, seating, and large windows overlooking the exterior."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 43,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-154f-7419-a19c-246ca746df63.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment buildings with a blue accent building featuring a grill area."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb31-70ab-84cc-bf7588e28f95.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and dark wood cabinets."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0830f-8f35-770f-83e8-e8d43f307397.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Heights at Happy Valley logo."
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08310-07c4-727c-9fe9-3dfe7376dd49.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Heights logo with mountain icon"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-74c8-7571-b034-00b53ef957eb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious modern lobby with a stone accent wall, fireplace, large sectional sofa, and contemporary decor."
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/interactive-map"
      }
    }
  },
  "featuring/luxury-apartments-with-pool-happy-valley-or::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-83e4-72ae-9cc0-f59b354108d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern community kitchen area with island seating and large windows."
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0dabd-05fa-7514-a8ba-c6f22d73509d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of modern apartment building with blue and white facade."
      }
    }
  },
  "liveworkunits.bedroomPhoto": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "liveworkunits.diningPhoto": {
    "sourceIndex": 45,
    "fieldOverrides": null
  },
  "liveworkunits.livingPhoto": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05874-a91b-7032-8aee-6eabe398b921.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony with a scenic view of a grassy field and trees."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0d574-ecb2-765c-9e48-cc38228d382f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier sit together on a shelf by a window, showcasing pet companionship."
      }
    }
  },
  "petpolicy.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Learn More"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "privacy-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a0830f-01e7-7506-8379-a4f2971d068d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Scenic mountain view with pine trees and a road."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a08312-eb9f-726e-af25-6d77be1dfb2a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and wood cabinets."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": 56,
    "fieldOverrides": null
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": 44,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167749/01a05871-d54c-72bb-9719-1996319147da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four young women lying on a picnic blanket in the grass, smiling and looking at a phone."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "specialofferbanner.offer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "<p><span style=\"font-size: 14px;\">Apply within 24 hours of your tour and we'll reimburse your application fee and drop your deposit to $99 on any floor plan. Three-bedroom homes also get 2 weeks free.</span></p>"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 63,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": [
      "ec_b4cedc377a13f964564a37cd",
      "ec_4a310f52ce409c4d29a63172",
      "ec_8743d9749157d3f7935633bf",
      "ec_1b0a4eacacbc2303b1a15932",
      "ec_fff001584b34f0fbc38d91e7",
      "ec_c9c2b204a1690688802a9e33",
      "ec_0919967dd2ca78a4634a7d52",
      "ec_30769a975e9e46933cd93553",
      "ec_c9fa2c61a975b5b0a0fd4987",
      "ec_dacab607921f70038d652782"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_01b55e65-a3c0-4be5-89c7-2eac2b13188a",
      "custom_02bdddb5-49b2-45b6-9c1d-ffe93360cbef",
      "custom_3411701f-a19a-44d6-943e-26b02715456d",
      "custom_65f1c4f5-e472-4bd3-8504-93a6a352e273",
      "custom_a8c66dc8-d8f2-4eae-bd22-be8c813df1fc",
      "custom_0dc3e857-1d9f-432a-9712-8d0ad6f62fbe",
      "custom_b52ebebc-02cd-4629-99cf-10ed3e72471f",
      "custom_8799eb28-bdec-4672-aea9-602ff4226a3b",
      "custom_240b0cc8-95cc-48e9-97c9-bccb2cbff317",
      "custom_8d1280a6-61da-457e-a071-b31eef71b3ef",
      "custom_6a843bb0-92a6-48ff-9007-9e6cf6d4f05e",
      "custom_5dfcadbd-303f-4dfc-b2ce-0ccfcbd5480a",
      "custom_4ce2be25-4b78-4877-b73a-8043bbcb8450",
      "custom_adf9c594-cd9b-43a6-8fa8-c3a88229b155",
      "custom_8a582cac-40ce-4b98-b58e-5cd278f57fe9",
      "custom_26189071-9590-4d4d-8a77-ad2f7da86a42",
      "custom_d9236d97-5ec8-47c4-8f00-b8c12f668759"
    ],
    "orderedIds": [
      "custom_65f1c4f5-e472-4bd3-8504-93a6a352e273",
      "custom_a8c66dc8-d8f2-4eae-bd22-be8c813df1fc",
      "custom_02bdddb5-49b2-45b6-9c1d-ffe93360cbef",
      "custom_0dc3e857-1d9f-432a-9712-8d0ad6f62fbe",
      "custom_b52ebebc-02cd-4629-99cf-10ed3e72471f",
      "custom_8799eb28-bdec-4672-aea9-602ff4226a3b",
      "custom_240b0cc8-95cc-48e9-97c9-bccb2cbff317",
      "custom_a8ab790a-dc95-4345-a819-934911dd6d4c",
      "custom_3e1d1eb9-20f0-43ab-b545-426a1f95e7a8",
      "custom_3411701f-a19a-44d6-943e-26b02715456d",
      "custom_341e9482-87cf-4a24-a38b-0261751f28ab",
      "custom_d9236d97-5ec8-47c4-8f00-b8c12f668759",
      "custom_4abee90f-bd62-4232-a332-41d1c42b9a08",
      "custom_8d1280a6-61da-457e-a071-b31eef71b3ef",
      "custom_6a843bb0-92a6-48ff-9007-9e6cf6d4f05e",
      "custom_2202ded3-b729-404e-84a2-5ecc85204738",
      "custom_5dfcadbd-303f-4dfc-b2ce-0ccfcbd5480a",
      "custom_1f52d703-31e0-43d4-9ea8-392371a59df1",
      "custom_adf9c594-cd9b-43a6-8fa8-c3a88229b155",
      "custom_4ce2be25-4b78-4877-b73a-8043bbcb8450",
      "custom_2b52e45e-f5bb-4800-b12b-51086c33ebbb",
      "custom_8a582cac-40ce-4b98-b58e-5cd278f57fe9",
      "custom_26189071-9590-4d4d-8a77-ad2f7da86a42",
      "custom_65ebfcfb-632f-4288-9352-fa4deb42a9bf",
      "custom_3a14e9e3-ea93-425e-89f5-81eca8d5bba7",
      "custom_e304cf87-30b4-4b8c-baee-08be30b64ad8",
      "custom_bd4156f2-83fb-4bd1-8b9d-e614ab050a49",
      "custom_7e01f356-cfb2-40e5-ae51-74a342197a32",
      "custom_dbe1eeb3-4b51-4526-b819-602331ad94a1",
      "custom_f90ddffc-0c52-476a-bb5b-1d0b6d3f2d21",
      "custom_d565dd54-1d2e-4a07-a282-3ff6797b9d6b",
      "custom_56952a44-b5f9-416e-9aa8-68ac58cea5ce",
      "custom_0d786575-1f4f-465d-8b3b-76107d4d6f2d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "ec_fdbb5ba06bec417d039ee339",
      "ec_19eb8a234fc3cbf4f8a0782f",
      "ec_62de82dbace7e2dd5d5cb8cc",
      "ec_86df5e47f5bb41b58b2d948b",
      "ec_b5d250223a060ef27ee81926",
      "ec_f8aaf96ec431569f1ff4089b",
      "ec_6abb894cce39e4b231754195",
      "ec_db64f9822f1695ef7c8cf617",
      "ec_037566d1a0c8a38d94455442",
      "ec_89f93119e5d4efea210aefd3",
      "ec_cb7c3d9e529f39f600b766c9"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_b6b79f4e-8529-473e-b07a-876d28f325cb",
      "custom_88b0ede2-8713-4539-8b1f-2c716b4a46ad",
      "custom_a19165dc-2f5c-49d0-8bcb-6b32b6662b09",
      "custom_a2a156cb-2b9e-47b1-a43e-0d228a68362b",
      "custom_3c52b8e3-b526-487a-8d6f-355659e42581",
      "custom_9abea54c-ccaa-4a47-9006-16b767c09f73",
      "custom_176f6c0c-975f-4ad5-a62c-40b8844c31c4",
      "custom_276fe8c1-5b38-41a6-b248-ba68f15e648f",
      "custom_e037a9bf-9a15-4770-a5ff-bf3bdea10868",
      "custom_fb4ec492-326a-460e-81cc-7a238f477b5f",
      "custom_57f9ac2f-cd85-4bb3-a65e-12f5b10736c0",
      "custom_422c7772-a1ec-48a8-a90c-587ceb53218c",
      "custom_4783925d-df60-41d3-9665-4eb779274210",
      "custom_ae751210-92e2-4e6e-9d01-9ea335457b52",
      "custom_c52f6852-9c2e-443a-bf8b-4a6c1484a97c",
      "custom_f5d15223-3174-42d3-87b5-f7e35f05e228",
      "custom_a14fff5c-d2c2-4495-b8bf-9150061a2462",
      "custom_ab5dcd07-e02e-48a7-aaef-653a5e73e518",
      "custom_97b13f84-5e22-4c1e-96bb-f27cee3052d9",
      "custom_07a2d8a1-930a-4c60-82ce-0171d8e77613",
      "custom_bf0e22cb-3552-4055-9b35-af9e3bbc0ac5"
    ],
    "orderedIds": [
      "custom_b6b79f4e-8529-473e-b07a-876d28f325cb",
      "custom_88b0ede2-8713-4539-8b1f-2c716b4a46ad",
      "custom_a19165dc-2f5c-49d0-8bcb-6b32b6662b09",
      "custom_a2a156cb-2b9e-47b1-a43e-0d228a68362b",
      "custom_f5d15223-3174-42d3-87b5-f7e35f05e228",
      "custom_3c52b8e3-b526-487a-8d6f-355659e42581",
      "custom_10a9e304-c4e2-4f0a-87af-5e130d198a03",
      "custom_c69f2ba6-e111-4f96-90b7-5387e6a1cda4",
      "custom_fcf4acb9-1cd8-42b5-a370-264e60a753c5",
      "custom_ea0b683c-1c11-41ba-bc2b-38c03db50033",
      "custom_4e7ba87e-e1b9-4a8c-83f8-649f5a1d8016",
      "custom_9abea54c-ccaa-4a47-9006-16b767c09f73",
      "custom_176f6c0c-975f-4ad5-a62c-40b8844c31c4",
      "custom_fb4ec492-326a-460e-81cc-7a238f477b5f",
      "custom_276fe8c1-5b38-41a6-b248-ba68f15e648f",
      "custom_e037a9bf-9a15-4770-a5ff-bf3bdea10868",
      "custom_57f9ac2f-cd85-4bb3-a65e-12f5b10736c0",
      "custom_ab5dcd07-e02e-48a7-aaef-653a5e73e518",
      "custom_422c7772-a1ec-48a8-a90c-587ceb53218c",
      "custom_4783925d-df60-41d3-9665-4eb779274210",
      "custom_ae751210-92e2-4e6e-9d01-9ea335457b52",
      "custom_bf0e22cb-3552-4055-9b35-af9e3bbc0ac5",
      "custom_c52f6852-9c2e-443a-bf8b-4a6c1484a97c",
      "custom_a14fff5c-d2c2-4495-b8bf-9150061a2462",
      "custom_a857f265-aca9-4eb5-8a1b-ef6895696ad9",
      "custom_97b13f84-5e22-4c1e-96bb-f27cee3052d9",
      "custom_07a2d8a1-930a-4c60-82ce-0171d8e77613",
      "custom_d9e1ffdf-af81-4aa4-a201-b134e5b75420",
      "custom_db850c3d-8c11-46cb-85c3-048b72692ae8",
      "custom_095c5d28-fa98-4924-8b0e-c8d9a9f7d229",
      "custom_e5b994cf-a2a1-4016-bbcc-a26fea47707e",
      "custom_b1ef1075-6a63-4f65-99fc-4265aaeb98d0",
      "custom_0223ffc1-c094-4fd0-83e6-27ce6d23bae7",
      "custom_4f885bf6-6359-44b7-a86f-72ccc8b506ec"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_8c944570-c43f-4b1b-bb53-e25583ddd515",
      "custom_36ce3323-ea66-47af-88c7-b08269bc0fd6",
      "custom_ed8f806f-e3f8-4d4d-a6a4-08ebd6bd1040",
      "custom_ce4817b9-c459-4be6-9302-c80edc98e66b",
      "custom_433531ae-890f-4148-92a1-6b0ceb0914b7",
      "custom_d6c5c34c-2f88-4a11-b18f-c021cc0b40f7",
      "custom_6a0e9c9c-daf0-4674-b68a-960a254349a3",
      "custom_839b918f-b5e8-416a-9bf7-bebb1a1f92a2",
      "custom_e6d0ecc7-8ed7-4ee7-9af7-fdf6bd1bdb22",
      "custom_01b55e65-a3c0-4be5-89c7-2eac2b13188a",
      "custom_43a20222-785a-4217-a19e-38ada457accd",
      "custom_54dc1a06-1a9d-4fc1-a6e5-afd9f2627ad3",
      "custom_ad51759f-ad69-4895-829e-f4ea9c79caa0",
      "custom_31455441-9a16-441e-b755-75f62d972b50",
      "custom_692c3454-a45c-4b9f-93a8-7d65071ea5e3",
      "custom_c99ffc3e-91fc-4a50-9b5a-68b30e17bc7a",
      "custom_726ea092-d9ab-4865-809d-9c6ec1a80a05",
      "custom_4517f398-1dfe-4273-9d49-17f6e1347a0f",
      "custom_3a7d1f98-26a4-4f78-b6d2-c57cf9903745",
      "custom_56952a44-b5f9-416e-9aa8-68ac58cea5ce",
      "custom_02bdddb5-49b2-45b6-9c1d-ffe93360cbef",
      "custom_07a2d8a1-930a-4c60-82ce-0171d8e77613",
      "custom_e5b994cf-a2a1-4016-bbcc-a26fea47707e",
      "custom_97b13f84-5e22-4c1e-96bb-f27cee3052d9",
      "custom_b1ef1075-6a63-4f65-99fc-4265aaeb98d0"
    ],
    "orderedIds": [
      "custom_db850c3d-8c11-46cb-85c3-048b72692ae8",
      "custom_65f1c4f5-e472-4bd3-8504-93a6a352e273",
      "custom_a8c66dc8-d8f2-4eae-bd22-be8c813df1fc",
      "custom_02bdddb5-49b2-45b6-9c1d-ffe93360cbef",
      "custom_0dc3e857-1d9f-432a-9712-8d0ad6f62fbe",
      "custom_b52ebebc-02cd-4629-99cf-10ed3e72471f",
      "custom_8799eb28-bdec-4672-aea9-602ff4226a3b",
      "custom_240b0cc8-95cc-48e9-97c9-bccb2cbff317",
      "custom_36ce3323-ea66-47af-88c7-b08269bc0fd6",
      "custom_8c944570-c43f-4b1b-bb53-e25583ddd515",
      "custom_ed8f806f-e3f8-4d4d-a6a4-08ebd6bd1040",
      "custom_839b918f-b5e8-416a-9bf7-bebb1a1f92a2",
      "custom_e6d0ecc7-8ed7-4ee7-9af7-fdf6bd1bdb22",
      "custom_ce4817b9-c459-4be6-9302-c80edc98e66b",
      "custom_433531ae-890f-4148-92a1-6b0ceb0914b7",
      "custom_01b55e65-a3c0-4be5-89c7-2eac2b13188a",
      "custom_d6c5c34c-2f88-4a11-b18f-c021cc0b40f7",
      "custom_6a0e9c9c-daf0-4674-b68a-960a254349a3",
      "custom_43a20222-785a-4217-a19e-38ada457accd",
      "custom_c99ffc3e-91fc-4a50-9b5a-68b30e17bc7a",
      "custom_726ea092-d9ab-4865-809d-9c6ec1a80a05",
      "custom_54dc1a06-1a9d-4fc1-a6e5-afd9f2627ad3",
      "custom_692c3454-a45c-4b9f-93a8-7d65071ea5e3",
      "custom_31455441-9a16-441e-b755-75f62d972b50",
      "custom_ad51759f-ad69-4895-829e-f4ea9c79caa0",
      "custom_4517f398-1dfe-4273-9d49-17f6e1347a0f",
      "custom_3a7d1f98-26a4-4f78-b6d2-c57cf9903745",
      "custom_3e1d1eb9-20f0-43ab-b545-426a1f95e7a8",
      "custom_3411701f-a19a-44d6-943e-26b02715456d",
      "custom_341e9482-87cf-4a24-a38b-0261751f28ab",
      "custom_a8ab790a-dc95-4345-a819-934911dd6d4c",
      "custom_d9236d97-5ec8-47c4-8f00-b8c12f668759",
      "custom_4abee90f-bd62-4232-a332-41d1c42b9a08",
      "custom_8d1280a6-61da-457e-a071-b31eef71b3ef",
      "custom_6a843bb0-92a6-48ff-9007-9e6cf6d4f05e",
      "custom_2202ded3-b729-404e-84a2-5ecc85204738",
      "custom_5dfcadbd-303f-4dfc-b2ce-0ccfcbd5480a",
      "custom_1f52d703-31e0-43d4-9ea8-392371a59df1",
      "custom_adf9c594-cd9b-43a6-8fa8-c3a88229b155",
      "custom_4ce2be25-4b78-4877-b73a-8043bbcb8450",
      "custom_2b52e45e-f5bb-4800-b12b-51086c33ebbb",
      "custom_8a582cac-40ce-4b98-b58e-5cd278f57fe9",
      "custom_26189071-9590-4d4d-8a77-ad2f7da86a42",
      "custom_65ebfcfb-632f-4288-9352-fa4deb42a9bf",
      "custom_3a14e9e3-ea93-425e-89f5-81eca8d5bba7",
      "custom_e304cf87-30b4-4b8c-baee-08be30b64ad8",
      "custom_bd4156f2-83fb-4bd1-8b9d-e614ab050a49",
      "custom_7e01f356-cfb2-40e5-ae51-74a342197a32",
      "custom_dbe1eeb3-4b51-4526-b819-602331ad94a1",
      "custom_f90ddffc-0c52-476a-bb5b-1d0b6d3f2d21",
      "custom_b6b79f4e-8529-473e-b07a-876d28f325cb",
      "custom_88b0ede2-8713-4539-8b1f-2c716b4a46ad",
      "custom_a19165dc-2f5c-49d0-8bcb-6b32b6662b09",
      "custom_a2a156cb-2b9e-47b1-a43e-0d228a68362b",
      "custom_f5d15223-3174-42d3-87b5-f7e35f05e228",
      "custom_ea0b683c-1c11-41ba-bc2b-38c03db50033",
      "custom_3c52b8e3-b526-487a-8d6f-355659e42581",
      "custom_4e7ba87e-e1b9-4a8c-83f8-649f5a1d8016",
      "custom_9abea54c-ccaa-4a47-9006-16b767c09f73",
      "custom_176f6c0c-975f-4ad5-a62c-40b8844c31c4",
      "custom_fb4ec492-326a-460e-81cc-7a238f477b5f",
      "custom_fcf4acb9-1cd8-42b5-a370-264e60a753c5",
      "custom_276fe8c1-5b38-41a6-b248-ba68f15e648f",
      "custom_e037a9bf-9a15-4770-a5ff-bf3bdea10868",
      "custom_c69f2ba6-e111-4f96-90b7-5387e6a1cda4",
      "custom_d565dd54-1d2e-4a07-a282-3ff6797b9d6b",
      "custom_56952a44-b5f9-416e-9aa8-68ac58cea5ce",
      "custom_0d786575-1f4f-465d-8b3b-76107d4d6f2d",
      "custom_10a9e304-c4e2-4f0a-87af-5e130d198a03",
      "custom_57f9ac2f-cd85-4bb3-a65e-12f5b10736c0",
      "custom_ab5dcd07-e02e-48a7-aaef-653a5e73e518",
      "custom_422c7772-a1ec-48a8-a90c-587ceb53218c",
      "custom_4783925d-df60-41d3-9665-4eb779274210",
      "custom_ae751210-92e2-4e6e-9d01-9ea335457b52",
      "custom_bf0e22cb-3552-4055-9b35-af9e3bbc0ac5",
      "custom_c52f6852-9c2e-443a-bf8b-4a6c1484a97c",
      "custom_a14fff5c-d2c2-4495-b8bf-9150061a2462",
      "custom_a857f265-aca9-4eb5-8a1b-ef6895696ad9",
      "custom_d9e1ffdf-af81-4aa4-a201-b134e5b75420",
      "custom_095c5d28-fa98-4924-8b0e-c8d9a9f7d229",
      "custom_4f885bf6-6359-44b7-a86f-72ccc8b506ec",
      "custom_0223ffc1-c094-4fd0-83e6-27ce6d23bae7",
      "custom_b1ef1075-6a63-4f65-99fc-4265aaeb98d0",
      "custom_e5b994cf-a2a1-4016-bbcc-a26fea47707e",
      "custom_07a2d8a1-930a-4c60-82ce-0171d8e77613",
      "custom_97b13f84-5e22-4c1e-96bb-f27cee3052d9"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
